export default (document) => {
  /**
   * Get a fresh region overlay SVG document.
   */
  const obj = document.createElement('object')
  obj.type = 'image/svg+xml'
  obj.data = `/static/images/mapOverlay.svg`

  return obj
}
